/** =========================================================
 * Projects controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-projects')
    .controller('ProjectsController', ProjectsController);

  ProjectsController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams', '$translate', '$anchorScroll', '$location', 'ngDialog'];

  function ProjectsController($rootScope, $scope, $api, $state, $stateParams, $translate, $anchorScroll, $location, ngDialog) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function  (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page projects',
        data: {
          filters: $stateParams.filters
        }
      });

      function array_move(arr, fromIndex, toIndex) {
        var element = arr[fromIndex];

        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
      }

      var filters = function () {
        if (typeof $location.search().id !== 'undefined') {
          return [{
            'attr': 'where',
            'name': '',
            'value': [['id', '=', $location.search().id]]
          }];
        }

        return angular.copy($stateParams.filters);
      };

      var resortIndicators = function (item) {
        item.project_indicators.map(function (projectIndicator, index) {
          projectIndicator.row_id = index;

          return projectIndicator;
        });
      };

      var prepareData = function (item) {
        return new Promise(function (resolve, reject) {
          try {
            var actions = [];

            actions.push(function () {
              return new Promise(function (actionResolve) {
                item.project_parts = (item.project_parts || []).map(function (projectPart) {
                  return {
                    id: projectPart.id,
                    project_id: projectPart.project_id,
                    overview: projectPart.overviewUpdated ? projectPart.overview : undefined,
                    prevent_overview_edit: projectPart.prevent_overview_edit,
                    inlcude_overview: projectPart.inlcude_overview
                  };
                });

                actionResolve();
              });
            });

            actions.push(function () {
              return new Promise(function (actionResolve) {
                item.project_acts = (item.project_acts || []).filter(function (act) {
                  return typeof act.type !== 'undefined';
                });

                item.project_acts.forEach(function (act) {
                  act.act_date = moment.isMoment(act.act_date) ? act.act_date.format($rootScope.appConfig.dateTimeFormat) : act.act_date;
                  act.project_part_acts = Object.values(act.project_part_acts);
                });

                actionResolve();
              });
            });

            item.project_approves = item.project_approves.filter(function (i) {
              return !!i.name;
            });

            item.project_indicators = item.project_indicators.filter(function (i) {
              return !!i.name;
            });

            item.project_documents = item.project_documents.filter(function (i) {
              return !!i.name;
            });

            item.project_files = item.project_files.filter(function (i) {
              return !!i.name;
            });

            $rootScope.helpers.promiseSequence(actions).then(function () {
              resolve(item);
            });
          } catch (error) {
            Raven.captureException(error);

            reject(error);
          }
        });
      };

      var getIndicatorTemplates = function () {
        return new Promise(function (resolve, reject) {
          try {
            var data = {
              selectOptions: ['id', 'name', 'user_id']
            };

            $api.resource({ model: 'project_indicator_template', data: data }).then(resolve);
          } catch (error) {
            Raven.captureException(error);

            reject(error);
          }
        });
      };

      var getDocumentTemplates = function () {
        return new Promise(function (resolve, reject) {
          try {
            var data = {
              selectOptions: ['id', 'name', 'user_id']
            };

            $api.resource({ model: 'project_document_template', data: data }).then(resolve);
          } catch (error) {
            Raven.captureException(error);

            reject(error);
          }
        });
      };

      var hasAct = function (stack, type) {
        try {
          return stack.filter(function (act) {
            return act.type === type;
          }).length !== 0;
        } catch (error) {
          Raven.captureException(error);
        }

        return false;
      };

      var addAct = function (item) {
        try {
          $scope.$applyAsync(function () {
            item.project_acts.push({
              project_id: item.id ? item.id : null,
              uid: item.uid + '.' + (item.project_acts.length + 1),
              act_date: moment(),
              project_part_acts: {},
              project_documents: [],
              project_indicators: [],
              project_approves: []
            });
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var addFile = function (item) {
        try {
          $scope.$applyAsync(function () {
            item.project_files.push({
              name: null,
              url: null
            });
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var addApprove = function (item) {
        try {
          $scope.$applyAsync(function () {
            item.project_approves.push({
              project_id: item.id ? item.id : null,
              name: null
            });
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var addDocument = function (item) {
        try {
          $scope.$applyAsync(function () {
            item.project_documents.push({
              project_id: item.id ? item.id : null,
              name: null
            });
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var addIndicator = function (item, index) {
        try {
          $scope.$applyAsync(function () {
            var newProjectIndicatorItem = {
              project_id: item.id ? item.id : null,
              name: null,
              value: null,
              row_id: index
            };

            item.project_indicators.splice(index, 0, newProjectIndicatorItem);

            resortIndicators(item);
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var removeItem = function (stack, index) {
        try {
          var dialogScope = $scope.$new(true);

          dialogScope.message = 'Do you really want to delete?';

          ngDialog.openConfirm({
            template: 'app/views/dialogs/confirm.html',
            scope: dialogScope
          }).then(function () {
            dialogScope.$applyAsync(function () {
              var item = stack[index];

              if (item.id) {
                item.deleted_at = moment();
              } else {
                stack.splice(index, 1);
              }
            });
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var getActItemStatus = function (actItemsStack, actStackItem) {
        try {
          var foundItems = actItemsStack.filter(function (actItemsStackItem) {
            if (actStackItem.id) {
              if (actItemsStackItem.id === actStackItem.id) {
                return true;
              }
            } else if (actItemsStackItem.name === actStackItem.name) {
              return true;
            }

            return false;
          }).length;

          return Boolean(foundItems);
        } catch (error) {
          Raven.captureException(error);
        }

        return false;
      };

      var prepareActOption = function (item) {
        try {
          return item.uid + ' ' + $translate.instant(item.type.capitalize()) + ': ' + item.act_date;
        } catch (error) {
          Raven.captureException(error);
        }

        return '';
      };

      var getProjectPartsLink = function (item) {
        try {
          $state.go('app.page-project-parts', {
            filters: [{
              name: $translate.instant('Project') + ': ' + item.uid + ' - ' + item.name,
              attr: 'where',
              value: [
                ['project_id', '=', item.id]
              ]
            }]
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var toggleActItem = function (actItemsStack, actStackItem) {
        try {
          $scope.$applyAsync(function () {
            var index = null;

            for (var i = 0; i < actItemsStack.length; i++) {
              if (actStackItem.id) {
                if (actItemsStack[i].id === actStackItem.id) {
                  index = i;
                  break;
                }
              } else if (actItemsStack[i].name === actStackItem.name) {
                index = i;
                break;
              }
            }

            if (index !== null) {
              actItemsStack.splice(index, 1);
            } else {
              actItemsStack.push(actStackItem);
            }
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var toggleActItems = function (projectAct, itemType, items) {
        try {
          $scope.$applyAsync(function () {
            if (projectAct[itemType].length === items.length) {
              projectAct[itemType] = [];
            } else {
              projectAct[itemType] = angular.copy(items);
            }
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var addIndicatorFromTemplates = function (item, index) {
        try {
          var dialogScope = $scope.$new(true);

          dialogScope.data = [];
          dialogScope.allData = [];
          dialogScope.loading = true;
          dialogScope.selectAllValue = false;
          dialogScope.showOnlyMineValue = false;
          dialogScope.helpers = {
            hasPermissionTo: $rootScope.helpers.hasPermissionTo
          };

          dialogScope.search = function (value) {
            dialogScope.$applyAsync(function () {
              dialogScope.loading = true;

              if (value && value !== '') {
                var searchItems = value.split(' ');

                dialogScope.data = dialogScope.allData.filter(function (dataItem) {
                  return searchItems.some(function (searchItem) {
                    return dataItem.name.toLowerCase().includes(searchItem.toLowerCase());
                  });
                });
              } else {
                dialogScope.data = dialogScope.allData;
              }

              dialogScope.loading = false;
            });
          };

          dialogScope.toggleSelectAll = function (value) {
            dialogScope.$applyAsync(function () {
              dialogScope.loading = true;
              dialogScope.data = dialogScope.data.map(function (dataItem) {
                dataItem.selected = !value;

                return dataItem;
              });
              dialogScope.loading = false;
            });
          };

          dialogScope.toggleShowOnlyMineValue = function () {
            dialogScope.$applyAsync(function () {
              dialogScope.showOnlyMineValue = !dialogScope.showOnlyMineValue;
            });
          };

          dialogScope.showValue = function (value) {
            if (dialogScope.showOnlyMineValue === true) {
              return value.user_id === $rootScope.appConfig.user.id;
            }

            return true;
          };

          dialogScope.addTemplate = function () {
            var dialogScope2 = $scope.$new(true);

            dialogScope2.item = {};

            ngDialog.openConfirm({
              template: 'app/views/dialogs/item-project-indicator-template.html',
              className: 'ngdialog-theme-default',
              scope: dialogScope2
            }).then(function () {
              dialogScope.loading = true;

              $api.add({
                model: 'project_indicator_template',
                data: dialogScope2.item
              }).then(function (response) {
                $api.getOne({
                  model: 'project_indicator_template',
                  data: {
                  },
                  id: response.data.id
                }).then(function (response2) {
                  dialogScope.allData.unshift(response2.data);
                  dialogScope.data.unshift(response2.data);
                  dialogScope.loading = false;
                }, function () {
                  dialogScope.loading = false;
                });
              }, function () {
                dialogScope.loading = false;
              });
            });
          };

          getIndicatorTemplates().then(function (response) {
            dialogScope.$applyAsync(function () {
              dialogScope.allData = response.data;
              dialogScope.data = response.data;
              dialogScope.loading = false;
            });
          });

          ngDialog.openConfirm({
            template: 'app/views/dialogs/project-indicator-templates.html',
            className: 'ngdialog-theme-default ngdialog-wide',
            scope: dialogScope
          }).then(function () {
            dialogScope.$applyAsync(function () {
              var newIndex = index;

              dialogScope.data.forEach(function (projectIndicatorTemplate) {
                if (projectIndicatorTemplate.selected) {
                  var newProjectIndicatorItem = {
                    project_id: item.id ? item.id : null,
                    name: projectIndicatorTemplate.name,
                    value: null,
                    row_id: newIndex
                  };

                  item.project_indicators.splice(newIndex, 0, newProjectIndicatorItem);

                  newIndex = (newIndex + 1);
                }
              });

              resortIndicators(item);
            });
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var addDocumentFromTemplates = function (item) {
        try {
          var dialogScope = $scope.$new(true);

          dialogScope.data = [];
          dialogScope.allData = [];
          dialogScope.loading = true;
          dialogScope.showOnlyMineValue = false;
          dialogScope.helpers = {
            hasPermissionTo: $rootScope.helpers.hasPermissionTo
          };

          dialogScope.search = function (value) {
            dialogScope.$applyAsync(function () {
              dialogScope.loading = true;

              if (value && value !== '') {
                var searchItems = value.split(' ');

                dialogScope.data = dialogScope.allData.filter(function (dataItem) {
                  return searchItems.some(function (searchItem) {
                    return dataItem.name.toLowerCase().includes(searchItem.toLowerCase());
                  });
                });
              } else {
                dialogScope.data = dialogScope.allData;
              }

              dialogScope.loading = false;
            });
          };

          dialogScope.toggleShowOnlyMineValue = function () {
            dialogScope.$applyAsync(function () {
              dialogScope.showOnlyMineValue = !dialogScope.showOnlyMineValue;
            });
          };

          dialogScope.showValue = function (value) {
            if (dialogScope.showOnlyMineValue === true) {
              return value.user_id === $rootScope.appConfig.user.id;
            }

            return true;
          };

          dialogScope.addTemplate = function () {
            var dialogScope2 = $scope.$new(true);

            dialogScope2.item = {};

            ngDialog.openConfirm({
              template: 'app/views/dialogs/item-project-document-template.html',
              className: 'ngdialog-theme-default',
              scope: dialogScope2
            }).then(function () {
              dialogScope.loading = true;

              $api.add({
                model: 'project_document_template',
                data: dialogScope2.item
              }).then(function (response) {
                $api.getOne({
                  model: 'project_document_template',
                  data: {
                  },
                  id: response.data.id
                }).then(function (response2) {
                  dialogScope.allData.unshift(response2.data);
                  dialogScope.data.unshift(response2.data);
                  dialogScope.loading = false;
                }, function () {
                  dialogScope.loading = false;
                });
              }, function () {
                dialogScope.loading = false;
              });
            });
          };

          getDocumentTemplates().then(function (response) {
            dialogScope.$applyAsync(function () {
              dialogScope.allData = response.data;
              dialogScope.data = response.data;
              dialogScope.loading = false;
            });
          });

          ngDialog.openConfirm({
            template: 'app/views/dialogs/project-document-templates.html',
            className: 'ngdialog-theme-default ngdialog-wide',
            scope: dialogScope
          }).then(function () {
            dialogScope.data.forEach(function (projectDocumentTemplate) {
              if (projectDocumentTemplate.selected) {
                item.project_documents.push({
                  project_id: item.id ? item.id : null,
                  name: projectDocumentTemplate.name
                });
              }
            });
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var getOverviewStart = function (item) {
        var projectPartTypeNames = (item.project_parts || []).map(function (project_part) {
          var suffix = (project_part.project_part_type_name_suffix
            ? ('. ' + project_part.project_part_type_name_suffix)
            : '');

          return project_part.project_part_type.name + suffix;
        }).join(', ');

        return $translate.instant('Project parts submitted for expertise') + ': ' + projectPartTypeNames + '.';
      };

      var getIndicatorsBlockSize = function (item, index) {
        var currentIndicator = item.project_indicators[index];

        if (index > 0) {
          var prevIndicator = item.project_indicators[index - 1];

          if (currentIndicator.reference_project_part_id === prevIndicator.reference_project_part_id) {
            return 0;
          }
        }

        var blockSize = 0;

        for (var i = index; i < item.project_indicators.length; i++) {
          var nextIndicator = item.project_indicators[i];

          if (currentIndicator.reference_project_part_id !== nextIndicator.reference_project_part_id) {
            break;
          }

          blockSize++;
        }

        return blockSize;
      };

      var moveIndicatorsBlockUp = function (item, index) {
        $scope.$applyAsync(function () {
          var currentIndicator = item.project_indicators[index];
          var blockSize = 0;
          var moveBlockSize = 0;

          for (var i = index; i < item.project_indicators.length; i++) {
            var nextIndicator = item.project_indicators[i];

            if (currentIndicator.reference_project_part_id !== nextIndicator.reference_project_part_id) {
              break;
            }

            blockSize++;
          }

          var prevIndicator = item.project_indicators[index - 1];

          for (var m = index - 1; m >= 0; m--) {
            var moveIndicator = item.project_indicators[m];

            if (prevIndicator.reference_project_part_id !== moveIndicator.reference_project_part_id) {
              break;
            }

            moveBlockSize++;
          }

          for (var n = 0; n < blockSize; n++) {
            array_move(item.project_indicators, (n + index), (n + index - moveBlockSize));
          }

          resortIndicators(item);
        });
      };

      var moveIndicatorsBlockDown = function (item, index) {
        $scope.$applyAsync(function () {
          var currentIndicator = item.project_indicators[index];
          var blockSize = 0;
          var moveBlockSize = 0;

          for (var i = index; i < item.project_indicators.length; i++) {
            var nextIndicator = item.project_indicators[i];

            if (currentIndicator.reference_project_part_id !== nextIndicator.reference_project_part_id) {
              break;
            }

            blockSize++;
          }

          var nextBlockIndicator = item.project_indicators[index + blockSize + 0];

          for (var m = (index + blockSize + 0); m < item.project_indicators.length; m++) {
            var moveIndicator = item.project_indicators[m];

            if (nextBlockIndicator.reference_project_part_id !== moveIndicator.reference_project_part_id) {
              break;
            }

            moveBlockSize++;
          }

          for (var n = 0; n < moveBlockSize; n++) {
            array_move(item.project_indicators, (n + index + blockSize), (n + index));
          }

          resortIndicators(item);
        });
      };

      var getCompanyName = function (item) {
        var foundCompany = $rootScope.appConfig.companies.find(function (company) {
          return item.company_id === company.id;
        });

        if (foundCompany) {
          return foundCompany.name;
        }

        return '';
      };

      var sortableOptions = {
        stop: function (e, ui) {
          try {
            for (var index in ui.item.sortable.sourceModel) {
              if (index) {
                ui.item.sortable.sourceModel[index].row_id = parseInt(index, 10);
              }
            }
          } catch (error) {
            Raven.captureException(error);
          }
        },
        uiOrderBy: 'row_id',
        axis: 'y'
      };

      vm.tableConfig = {
        model: 'project',
        getDataParams: {
          order: {
            created_at: 'desc'
          },
          with: [{
            project_type: ['id', 'name', 'slug']
          }, {
            project_building_type: ['id', 'name']
          }, {
            user: ['id', 'name']
          }, {
            customer: ['id', 'name']
          }, {
            contractor: ['id', 'name']
          }, {
            projector: ['id', 'name']
          }, {
            projector_employee: ['id', 'name']
          }, {
            projector_employee_certificate: ['id', 'uid', 'name', 'issue_date']
          },
          'project_parts.project_part_type&user&project_part_acts',
          'project_acts.project_part_acts&project_documents&project_indicators&project_approves',
          'project_documents',
          'project_indicators',
          'project_approves',
          'project_files'
          ],
          where: [
            ['archived', '=', false]
          ]
        },
        filters: filters(),
        helpers: {
          hasAct: hasAct,
          addAct: addAct,
          addFile: addFile,
          addApprove: addApprove,
          addDocument: addDocument,
          addIndicator: addIndicator,
          removeItem: removeItem,
          prepareActOption: prepareActOption,
          getProjectPartsLink: getProjectPartsLink,
          toggleActItem: toggleActItem,
          toggleActItems: toggleActItems,
          getActItemStatus: getActItemStatus,
          addIndicatorFromTemplates: addIndicatorFromTemplates,
          addDocumentFromTemplates: addDocumentFromTemplates,
          sortableOptions: sortableOptions,
          hasPermissionTo: $rootScope.helpers.hasPermissionTo,
          searchResource: $rootScope.helpers.searchResource,
          colorCode: $rootScope.helpers.colorCode,
          getOverviewStart: getOverviewStart,
          getIndicatorsBlockSize: getIndicatorsBlockSize,
          moveIndicatorsBlockUp: moveIndicatorsBlockUp,
          moveIndicatorsBlockDown: moveIndicatorsBlockDown,
          getCompanyName: getCompanyName,
          moment: moment
        },
        itemLoader: true,
        lists: {
          act_types: ['initial', 'final']
        },
        resources: [
          'contractor',
          'customer',
          'customer_employee',
          'project_building_type',
          'project_type',
          'projector',
          'projector_employee',
          'projector_employee_certificate',
          'user',
          'user_certificate'
        ],
        resourceUpdateConditions: {
          projector_employee: {
            watch: 'projector_id',
            params: function (item) {
              return {
                projector_id: item.projector_id ? item.projector_id : 0
              };
            }
          },
          customer_employee: {
            watch: 'customer_id',
            params: function (item) {
              return {
                customer_id: item.customer_id ? item.customer_id : 0
              };
            }
          },
          user_certificate: {
            watch: 'user_id',
            params: function (item) {
              return {
                selectOptions: ['id', 'uid', 'name', 'issue_date'],
                user_id: item.user_id ? item.user_id : 0
              };
            }
          },
          projector_employee_certificate: {
            watch: 'projector_employee_id',
            params: function (item) {
              return {
                selectOptions: ['id', 'uid', 'name', 'issue_date'],
                projector_employee_id: item.projector_employee_id ? item.projector_employee_id : 0
              };
            }
          }
        },
        fields: [{
          title: 'ID',
          key: 'uid',
          order: true
        }, {
          title: 'Type',
          key: 'project_type_id',
          order: true
        }, {
          title: 'Building type',
          key: 'project_building_type_id',
          order: true
        }, {
          title: 'Title',
          key: 'name',
          order: true
        }, {
          title: 'Customer',
          key: 'customer_id',
          order: true
        }, {
          title: 'Projector',
          key: 'projector_id',
          order: true
        }, {
          title: 'Responsible user',
          key: 'user_id',
          order: true
        }, {
          title: 'Deadline',
          key: 'deadline',
          order: true
        }, {
          title: 'Received',
          key: 'received',
          order: true
        }, {
          title: 'Date',
          key: 'created_at',
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-project.html',
          superWide: true,
          item: {
            project_acts: [],
            project_files: [],
            project_documents: [],
            project_indicators: [],
            project_approves: [],
            project_parts: []
          },
          before: function (item) {
            return new Promise(function (resolve, reject) {
              try {
                $api.resource({
                  model: 'project_attribute'
                }).then(function (response) {
                  item.attributes = response.data.map(function (attr) {
                    return {
                      name: attr.name,
                      value: false
                    };
                  });

                  resolve();
                });
              } catch (error) {
                Raven.captureException(error);

                reject(error);
              }
            });
          },
          beforeSubmit: prepareData
        },
        edit: {
          template: 'app/views/dialogs/item-project.html',
          superWide: true,
          except: [
            'project_type',
            'project_building_type',
            'user',
            'projector',
            'contractor',
            'customer',
            'projector_employee',
            'projector_employee_certificate'
          ],
          before: function (item) {
            return new Promise(function (resolve, reject) {
              try {
                item.project_acts.forEach(function (act) {
                  var new_project_part_acts = {};

                  act.project_part_acts.forEach(function (project_part_act) {
                    new_project_part_acts[project_part_act.project_part_id] = project_part_act;
                  });

                  act.project_part_acts = new_project_part_acts;
                });

                resolve();
              } catch (error) {
                Raven.captureException(error);

                reject(error);
              }
            });
          },
          beforeSubmit: prepareData
        },
        delete: {}
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
